import type { IconData } from '@stacksjs/iconify-core'

export const horizontalMenuCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0\"/><path d=\"M20.5 24a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0m-12 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0m24 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default horizontalMenuCircle
